import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    isAuthenticated: false,
    roleId: '',
    roleName: '',
    assignedStores: [],
    loginAt: null,
    lastActivity: null,
  },
  reducers: {
    loginSuccess(state, action) {
      const { user, roleId, roleName, assignedStores } = action.payload;
      state.user = user;
      state.isAuthenticated = true;
      state.roleId = roleId;
      state.roleName = roleName;
      state.assignedStores = assignedStores || [];
      state.loginAt = Date.now();
      state.lastActivity = Date.now();
    },
    extendSession(state) {
      state.lastActivity = Date.now();
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.roleId = '';
      state.roleName = '';
      state.assignedStores = [];
      state.loginAt = null;
      state.lastActivity = null;
    },
  },
});

export const { loginSuccess, extendSession, logout } = userSlice.actions;
export default userSlice.reducer;
